/* eslint-disable @typescript-eslint/no-explicit-any */
import {useFormik} from "formik";
import {useDispatch, useSelector} from "react-redux";
import {notification} from "@/store/modules/notification";
import {StoreUtil} from "@/util/store/StoreUtil";
import {CreateEntityRequest, EntityRequestInit,} from "@/model/request/entity/CreateEntityRequest";
import {entity} from "@/store/modules/entity";
import {BaseInput} from "../input/BaseInput";
import {EntityValidation} from "./validation/EntityValidation.ts";
import {RootState} from "@/store";
import {NewModuleType} from "./NewApplicationForm.tsx";


export default function NewEntityForm({onClose, data}: NewModuleType) {
    const selectedApplication = useSelector((state: RootState) => state.application.selectedApplication)
    const dispatch = useDispatch<any>();
    const entityState = useSelector((state: RootState) => state.entity)

    const showMessage = (response: any) => {
        StoreUtil.execute(() => {
                dispatch(
                    notification.mutation.openModal({
                        type: "success",
                        title: "Success",
                        body: response.responseMessage,
                    })
                )
                dispatch(entity.action.readByEntityApplicationId({entityApplicationId: selectedApplication?.applicationId ? selectedApplication?.applicationId : 0}))
            }
        );
        onClose()
    };

    console.log(`data`, data)

    const handleSubmit = async (value: CreateEntityRequest) => {
        const request = {...value, entityApplicationId: selectedApplication?.applicationId}
        const updateRequest = {
            ...value,
            entityApplicationId: selectedApplication?.applicationId ? selectedApplication?.applicationId : 0,
            entityId: data?.entityId,
            entityStatus: data?.entityStatus
        }
        data ? await dispatch(
            entity.action.update({
                data: updateRequest,
                onSuccess: (response: any) => showMessage(response),
                onError: (response: any) => showMessage(response),
            })
        ) : await dispatch(
            entity.action.create({
                data: request,
                onSuccess: (response: any) => showMessage(response),
                onError: (response: any) => showMessage(response),
            })
        );
    };

    const formik = useFormik({
        onSubmit: handleSubmit,
        initialValues: data ? data : EntityRequestInit,
        validationSchema: EntityValidation.create,
    });

    console.log(data)
    return (
        <>
            <form onSubmit={formik.handleSubmit}>
                <div style={{marginBottom: "2rem"}}>
                    <label className="field-label">Entity name</label>
                    <BaseInput
                        formik={formik}
                        className="form_input w-input"
                        maxLength={256}
                        name="entityName"
                        data-name="Field 5"
                        placeholder="Enter entity name"
                        type="text"
                        id="entity name"
                        required
                    />
                </div>

                <label className="field-label">Description</label>
                <BaseInput
                    formik={formik}
                    className="form_input w-input"
                    maxLength={256}
                    name="entityDescription"
                    data-name="Field 5"
                    placeholder="Enter entity name"
                    type="text"
                    id="entity name"
                    required
                />
                <div className="div-block-5" style={{display: "flex", gap: "1rem", justifyContent: "left"}}>
                    <BaseInput
                        type="submit"
                        formik={formik}
                        className="button w-button"
                        name={"new"}
                        loading={entityState.loading}
                        value={data ? "Update entity" : "Add new entity"}
                        id="new entity"
                    />
                    <a className="button is-secondary w-button" onClick={onClose}>Cancel</a>
                </div>
            </form>
        </>
    );
}
